define(function() {

  return [
{
  "Name": "berrynes_area_3857",
  "Title": "berrynes_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "berrynes_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=berrynes_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "blueberry_area_3857",
  "Title": "blueberry_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "blueberry_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=blueberry_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "brazil_area_3857",
  "Title": "brazil_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "brazil_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=brazil_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "broadbean_area_3857",
  "Title": "broadbean_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "broadbean_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=broadbean_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "buckwheat_area_3857",
  "Title": "buckwheat_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "buckwheat_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=buckwheat_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cabbagefor_area_3857",
  "Title": "cabbagefor_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cabbagefor_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cabbagefor_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "canaryseed_area_3857",
  "Title": "canaryseed_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "canaryseed_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=canaryseed_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "carob_area_3857",
  "Title": "carob_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "carob_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=carob_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "carrotarea_3857",
  "Title": "carrotarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "carrotarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=carrotarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "carrotforarea_3857",
  "Title": "carrotforarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "carrotforarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=carrotforarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cashewapplearea_3857",
  "Title": "cashewapplearea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cashewapplearea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cashewapplearea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cashewarea_3857",
  "Title": "cashewarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cashewarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cashewarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cassavaarea_3857",
  "Title": "cassavaarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cassavaarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cassavaarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "castorarea_3857",
  "Title": "castorarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "castorarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=castorarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cauliflowerarea_3857",
  "Title": "cauliflowerarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cauliflowerarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cauliflowerarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cerealnesarea_3857",
  "Title": "cerealnesarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cerealnesarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cerealnesarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cherryarea_3857",
  "Title": "cherryarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cherryarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cherryarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "chestnutarea_3857",
  "Title": "chestnutarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "chestnutarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chestnutarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "chickpeaarea_3857",
  "Title": "chickpeaarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "chickpeaarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chickpeaarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "chicoryarea_3857",
  "Title": "chicoryarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "chicoryarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chicoryarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "chilietcarea_3857",
  "Title": "chilietcarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "chilietcarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=chilietcarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cinnamonarea_3857",
  "Title": "cinnamonarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cinnamonarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cinnamonarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "citrusnesarea_3857",
  "Title": "citrusnesarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "citrusnesarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=citrusnesarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "clovearea_3857",
  "Title": "clovearea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "clovearea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=clovearea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cloverarea_3857",
  "Title": "cloverarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cloverarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cloverarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cocoaarea_3857",
  "Title": "cocoaarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cocoaarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cocoaarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "coconutarea_3857",
  "Title": "coconutarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "coconutarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=coconutarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "coffeearea_3857",
  "Title": "coffeearea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "coffeearea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=coffeearea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "coirarea_3857",
  "Title": "coirarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "coirarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -179.99999237060547,
    -85.87863889373075,
    179.98662764288167,
    85.81776046752934
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037507.49348893,
        -21205770.720520623,
        20036019.738804124,
        21112163.63770032
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=coirarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cottonarea_3857",
  "Title": "cottonarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cottonarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cottonarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "cowpeaarea_3857",
  "Title": "cowpeaarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "cowpeaarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=cowpeaarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},    
{
  "Name": "abacaarea_3857",
  "Title": "abacaarea_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "abacaarea_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=abacaarea_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "agave_area_3857",
  "Title": "agave_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "agave_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=agave_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "alfalfa_area_3857",
  "Title": "alfalfa_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "alfalfa_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=alfalfa_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "almond_area_3857",
  "Title": "almond_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "almond_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=almond_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "aniseetc_area_3857",
  "Title": "aniseetc_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "aniseetc_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=aniseetc_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "apple_area_3857",
  "Title": "apple_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "apple_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=apple_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "apricot_area_3857",
  "Title": "apricot_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "apricot_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=apricot_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "areca_area_3857",
  "Title": "areca_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "areca_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=areca_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "artichoke_area_3857",
  "Title": "artichoke_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "artichoke_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=artichoke_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "asparagus_area_3857",
  "Title": "asparagus_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "asparagus_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=asparagus_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "avocado_area_3857",
  "Title": "avocado_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "avocado_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=avocado_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "bambara_area_3857",
  "Title": "bambara_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "bambara_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=bambara_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
},
{
  "Name": "banana_area_3857",
  "Title": "banana_area_3857",
  "Abstract": "",
  "KeywordList": [
    "WCS",
    "GeoTIFF",
    "banana_area_3857"
  ],
  "SRS": [
    "EPSG:3857"
  ],
  "LatLonBoundingBox": [
    -180.00000000000003,
    -85.81552819353568,
    179.95503414565607,
    85.81395348836212
  ],
  "BoundingBox": [
    {
      "crs": "EPSG:3857",
      "extent": [
        -20037508.342789248,
        -21108757.183934048,
        20032502.766780593,
        21106355.272253364
      ],
      "res": [
        null,
        null
      ]
    }
  ],
  "Style": [
    {
      "Name": "earthstat_crop_area_EN",
      "Title": "Rain distribution",
      "Abstract": "",
      "LegendURL": [
        {
          "Format": "image/png",
          "OnlineResource": "http://fenix.fao.org:20200/geoserver/earthstat/wms?request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=banana_area_3857",
          "size": [
            20,
            20
          ]
        }
      ]
    }
  ],
  "queryable": true,
  "opaque": false,
  "noSubsets": false
}
];

});


//////////////////
// WEBPACK FOOTER
// ./src/config/tabs/map-earthstat-layers.js
// module id = 44
// module chunks = 0